import ProjectsContainer from "../components/Projects/ProjectsContainer";


export default function Portfolio() {
  return (
    <ProjectsContainer />
  );
}
